import {
  FETCH_BANKS_REQUEST,
  SAVE_BANK_REQUEST,
  CHANGE_BANK_STATUS_REQUEST,
} from "./actionTypes";

export const fetchBanks = (unitId) => ({
  type: FETCH_BANKS_REQUEST,
  payload: { unitId }
});

export const saveBank = (data) => ({
  type: SAVE_BANK_REQUEST,
  payload: data,
});

export const changeBankStatus = (payload) => ({
  type: CHANGE_BANK_STATUS_REQUEST,
  payload,
});
